module.exports = __webpack_public_path__ + "static/media/image_9.6a0e0c79.png";